import { Observable } from '@code-expert/fp-ts-rxjs';
import { pipe, record } from '@code-expert/prelude';
import { publicationEventAdt } from './PublicationEvent.js';
const upsert = (a) => (old) => ({
    ...old,
    [a._id]: a,
});
const del = (_id) => (old) => {
    if (!(_id in old))
        return old;
    const copy = { ...old };
    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete copy[_id];
    return copy;
};
const getId = (e) => e._id;
export const publicationSetReducer = (event) => (prevState) => {
    const panic = (message) => {
        const cause = { prevState, event };
        throw new Error(message, { cause });
    };
    return publicationEventAdt().fold(event, {
        initial: record.indexBy(getId),
        insert: (a) => pipe(prevState, upsert(a)),
        update: (a) => {
            if (!(a._id in prevState))
                panic('Entity Collection received update for non-existent entity');
            return pipe(prevState, upsert(a));
        },
        delete: (id) => pipe(prevState, del(id)),
    });
};
export const aggregatePublicationSet = () => (source) => new Observable((subscriber) => {
    let state;
    return source.subscribe({
        complete: () => void subscriber.complete(),
        error: (e) => void subscriber.error(e),
        next: (event) => {
            if (state == null) {
                if (event._tag !== 'initial') {
                    subscriber.error(new Error(`Cannot apply ${event._tag} event to uninitialised publication set`));
                    return;
                }
                state = {};
            }
            try {
                subscriber.next((state = publicationSetReducer(event)(state)));
            }
            catch (e) {
                subscriber.error(e);
            }
        },
    });
});
//# sourceMappingURL=PublicationSet.js.map